import { render, staticRenderFns } from "./StructureGraphs.vue?vue&type=template&id=56c70b9c&scoped=true&"
import script from "./StructureGraphs.vue?vue&type=script&lang=ts&"
export * from "./StructureGraphs.vue?vue&type=script&lang=ts&"
import style0 from "./StructureGraphs.vue?vue&type=style&index=0&id=56c70b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c70b9c",
  null
  
)

export default component.exports